module.exports = __webpack_public_path__ + "img/LocationDefault.f2811a1d.svg";